module.exports = "<p>\r\n  searchresultlistitem works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/search/searchresultlistitem/searchresultlistitem.component.html
// module id = ./src/app/search/searchresultlistitem/searchresultlistitem.component.html
// module chunks = main